import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { previewMessage, type PreviewTarget, type SendMessageInput } from '@/api/messages'
import { useDebouncedValue } from '@/lib/useDebouncedValue'

/**
 * The server-rendered preview of a draft — the same rendering a send uses, so sender, signature, tokens
 * and footer are exactly what the recipient will get. Debounced while typing; null without a target.
 */
export function useMessagePreview(target: PreviewTarget | undefined, input: SendMessageInput) {
  const debounced = useDebouncedValue(input)
  return useQuery({
    queryKey: ['message-preview', target?.kind, target?.id, debounced],
    queryFn: () => previewMessage(target!, debounced),
    enabled: !!target,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  })
}
